import Cancellation24Hours from '../src/Cancellation24Hours/index.tsx';
export default Cancellation24Hours;
